import { store } from "../store"
import ru from "./ru"
import en from "./en"

const translations = { ru, en }

export const t = (key) => {
    const lang = store.getState().language
    const dict = translations[lang] || ru
    return dict[key] !== undefined ? dict[key] : key
}
